var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"fonts-component"},_vm._l((_vm.components),function(f,i){return _c('li',{key:i,staticClass:"fonts-component__item",class:{ 'fonts-component__item--active': f.active },style:({ fontFamily: f.identifier }),on:{"click":function($event){return _vm.select(f)}}},[_vm._v(" A ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }